import styled from 'styled-components';
import { Link as L } from 'redux-little-router';


export const Link = styled(L)`
  &:focus,
  &:hover {
    text-decoration: none;
    color: unset;
  }
`;



// WEBPACK FOOTER //
// ./src/components/ui-helpers/link.js